<script setup>
import { toRefs, ref } from 'vue'

const props = defineProps({
  label: {
    type: String
  },
  type: {
    type: String,
    default: 'text'
  },
  name: {
    type: String
  },
  required: {
    type: Boolean
  },
  customValidate: {
    type: Boolean
  },
  customValidateText: {
    type: String
  },
  maxlength: {
    type: Number,
    default: 100
  },
  enterPrevent: {
    type: Boolean,
    default: () => {
      return true
    }
  },
  noRequiredMask: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['blur'])

const {
  label,
  type,
  name,
  required,
  customValidate,
  customValidateText,
  enterPrevent,
  noRequiredMask
} = toRefs(props)

const enterHandler = (event) => {
  if (enterPrevent.value) event.preventDefault()
}

// handle no keep-space modifier

const inputRef = ref(null)

const [modelValue, modelModifier] = defineModel({
  type: [String, Number],
  get: (value) => (value === 'null' ? null : value)
})

const handleBlur = () => {
  if (!modelModifier['keep-space'] && typeof modelValue.value === 'string') {
    const trimmedValue = modelValue.value.trim()
    modelValue.value = trimmedValue

    if (inputRef.value && inputRef.value.value !== trimmedValue) {
      inputRef.value.value = trimmedValue
    }
    emit('blur', trimmedValue)
  } else {
    emit('blur', modelValue.value)
  }
}
</script>

<template>
  <label>
    <p v-if="label" class="flex gap-1 py-1">
      <span>{{ label }}</span>
      <span v-if="required && !noRequiredMask" class="text-sm font-light text-red-400">*</span>
    </p>
    <div>
      <input
        ref="inputRef"
        :type="type"
        :name="name"
        :maxlength="maxlength"
        v-model="modelValue"
        @blur="handleBlur"
        @keydown.enter="enterHandler"
        :class="['custom-input', { 'custom-validate-input': customValidate }]"
        :required="required"
        autocomplete="off"
        v-bind="$attrs"
      />
      <p v-if="customValidate" class="custom-validate-message">
        {{ customValidateText }}
      </p>
    </div>
  </label>
</template>

<style lang="scss" scoped>
input[disabled] {
  color: #6a7282;
}
</style>
